import api from "./apiService";
import qs from 'qs';
export const AddTest = async (data) => {
  try {
    const response = await api.post("/Home/AddTest", {
      CATEGORY_CODE: data.CATEGORY_CODE || "0",
      GenderCategory: data.GenderCategory || "0",
      AGE_CODE: data.AGE_CODE || "0",
      TestID: data.TestID || 0,
      TestName: data.test_name,
      TestPrice: data.TestPrice,
      Unit: data.Unit,
      NormalRange: data.Reference_value,
      Comments: data.Comments,
      LaboratoryID: sessionStorage.getItem("LabID"),
      SUB_CATEGORY_CODE: data.SUB_CATEGORY_CODE || "0",
    });
    return response.data;
  } catch (error) {
    console.error("Add Test error", error);
    throw error;
  }
};

export const RetriveTest = async (Params) => {
  try {
    const response = await api.get(`/Home/GetTests`, {
      params: {
        LabID: Params.LabID,
        CATEGORY_CODE: Params.CATEGORY_CODE || "0",
        GenderCatagory: Params.GenderCategory || "0",
        AGE_CODE: Params.AGE_CODE || "0",
        SUB_CATEGORY_CODE: Params.SUB_CATEGORY_CODE || "0",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Retrieve Test error", error);
    throw error;
  }
};

export const GetDataBySearch = async (Params) => {
  try {
    const response = await api.get(`/Home/GetTestforSearch`, {
      params: { LabID: Params.LabID },
    });
    return response.data;
  } catch (error) {
    console.error("Search Test error", error);
    throw error;
  }
};

export const GetPrescription = async (patientID, LabID) => {
  try {
    const response = await api.get(`/Home/GetLabOrderDatas`, {
      params: { PatientID: patientID, LabID },
    });
    return response.data;
  } catch (error) {
    console.error("Get Prescription error", error);
    throw error;
  }
};

export const Reports = async (patientID, LabID, TestIDs) => {
  try {
    
    const response = await api.get(`/Home/Reports`, {
      params: {
        PatientID: patientID,
        LabID:LabID,
        SelectedIDs: TestIDs,
      },
       paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }), // This creates multiple SelectedIDs=
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const GetSingleTest = async (TestID, LabID) => {
  try {
    const response = await api.get(`/Home/GetSinglTetest`, {
      params: { LabID, TestID },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const DeleteTest = async (TestID, LabID) => {
  try {
    const response = await api.post(
      `/Home/DeleteTest?LabID=${LabID}&TestID=${TestID}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const Generate_Reports = async (G_Report) => {
  try {
    const response = await api.post("/Home/Generate_Report", {
      reportID: G_Report.reportID,
      patientID: G_Report.patientID,
      testResult: G_Report.testResult,
      testID: G_Report.testID,
      laboratoryID:
        G_Report.laboratoryID || sessionStorage.getItem("LabID"),
      comment: G_Report?.Comment,
      labOrderID_In_GR: G_Report.labOrderID_In_GR,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const Add_TestSettings = async (formData) => {
  try {
    const payload = {
      laboratoryid: formData.LabID,
      categorY_VALUE: formData.CataGory_Value || "Null",
      suB_CATEGORY_VALUE: formData.sub_Categorry || "Null",
      agE_VALUE: formData.Age_Value || "Null",
      sResult: formData.StaticResult || "Null",
    };
    const response = await api.post("/Home/Add_TestSettings", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const Get_Categorry = async (Labid) => {
  try {
    const response = await api.get(`/Home/Get_Categorry`, {
      params: { LabID: Labid },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const Get_AgeGroup = async (Labid) => {
  try {
    const response = await api.get(`/Home/Get_AgeGroup`, {
      params: { LabID: Labid },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const Get_SubCategory = async (Labid) => {
  try {
    const response = await api.get(`/Home/GetSubTestCategory`, {
      params: { LabID: Labid },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetDoctorInfo = async (Labid) => {
  try {
    const response = await api.get(`/Home/GetDoctorInfo`, {
      params: { LabID: Labid },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};



export const ToggleFavoriteCategory = async (LabID, CATEGORY_CODE, IsFavorite) => {
  try {
    const response = await api.post(
      `/Home/ToggleFavoriteCategory?LabID=${LabID}&CATEGORY_CODE=${CATEGORY_CODE}&IsFavorite=${IsFavorite}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ToggleFavoriteSubCategory = async (LabID, SUB_CATEGORY_CODE, IsFavorite) => {
  try {
    const response = await api.post(
      `/Home/ToggleFavoriteSubCategory?LabID=${LabID}&SUB_CATEGORY_CODE=${SUB_CATEGORY_CODE}&IsFavorite=${IsFavorite}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ToggleFavoriteTest = async (LabID, TestID, IsFavorite) => {
  try {
    const response = await api.post(
      `/Home/ToggleFavoriteTest?LabID=${LabID}&TestID=${TestID}&IsFavorite=${IsFavorite}`,
      {}
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetStaticResult = async (Labid) => {
  try {
    const response = await api.get(`/Home/GetStaticResult`, {
      params: { LabID: Labid },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
